import { LOCALES, KEYS } from '../constants';

const krKOTranslations = Object.freeze({
  [LOCALES.L18N_LOCALE_KOREA_KO]: {
    [KEYS.L18N_KEY_LABEL_PARTNER_ROLE ]:"파트너 역할",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR ]:"통합자",
    [KEYS.L18N_KEY_LABEL_PROVIDER ]:"Provider(사업자)",
    [KEYS.L18N_KEY_LABEL_PARTNER_LEVEL]:"파트너 레벨",
    [KEYS.L18N_KEY_LABEL_PARTNER_SPECIALIZATION ]:"파트너 Specialization",
    [KEYS.L18N_KEY_LABEL_CISCO_POWERED_SERVICE ]:" Cisco Powered Service",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME ]:"파트너 이름",
    [KEYS.L18N_KEY_LABEL_LOCATION ]:"위치",
    [KEYS.L18N_KEY_LABEL_COUNTRY ]:"국가",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME_KEYWORD ]:"파트너 이름 키워드",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME_KEYWORD_S_ ]:"파트너 이름 키워드",
    [KEYS.L18N_KEY_LABEL_SORTING ]:"정렬",
    [KEYS.L18N_KEY_LABEL_SPECIALIZATIONS ]:"전문화(Specializations)",
    [KEYS.L18N_KEY_LABEL_PARTNER_SPECIALIZATIONS ]:"파트너 Specialization",
    [KEYS.L18N_KEY_LABEL_PROVIDER_LEVEL_AND_CISCO_POWERED_SERVICES ]:"공급자 레벨 및 Cisco Powered Service",
    [KEYS.L18N_KEY_LABEL_GOLD_PROVIDER ]:"Gold 공급자",
    [KEYS.L18N_KEY_LABEL_PREMIER_PROVIDER ]:"Premier 공급자",
    [KEYS.L18N_KEY_LABEL_SELECT_PROVIDER ]:"공급자 선택",
    [KEYS.L18N_KEY_LABEL_ELOQUA__GET_GUIDANCE]:"안내받기",
    [KEYS.L18N_KEY_LABEL_ELOQUA__REQUEST_A_QUOTE ]:"견적 요청",
    [KEYS.L18N_KEY_LABEL_OPEN ]:"열림",
    [KEYS.L18N_KEY_LABEL_EXPAND ]:"확대",
    [KEYS.L18N_KEY_LABEL_COLLAPSE ]:"축소",
    [KEYS.L18N_KEY_LABEL_CHOOSE_A_COUNTRY ]:"국가/지역 선택",
    [KEYS.L18N_KEY_LABEL_CHOOSE_A_ROLE ]:"역할 선택",
    [KEYS.L18N_KEY_LABEL_CHOOSE_SPECIALIZATION_S_ ]:"Specialization 선택",
    [KEYS.L18N_KEY_LABEL_CHOOSE_CISCO_POWERED_SERVICE_S_ ]:"Cisco Powered Service 선택",
    [KEYS.L18N_KEY_LABEL_CHOOSE_EXPERTISE_S]:"전문 지식 선택",
    [KEYS.L18N_KEY_LABEL_CHOOSE_LEVEL_S_ ]:"레벨 선택",
    [KEYS.L18N_KEY_LABEL_PARTNER_COUNTRY ]:"파트너 국가/지역",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR_LEVELS ]:"통합자 레벨",
    [KEYS.L18N_KEY_LABEL_PROVIDER_LEVELS ]:"공급자 레벨",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR_SPECIALIZATIONS ]:"통합자 Specialization",
    [KEYS.L18N_KEY_LABEL_CISCO_POWERED_SERVICES ]:"Cisco Powered Service",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAMES ]:"파트너 이름",
    [KEYS.L18N_KEY_LABEL_BACK ]:"뒤로",
    [KEYS.L18N_KEY_LABEL_ALL_RESULTS]:"모든 결과",
    [KEYS.L18N_KEY_LABEL_ALL ]:"모두",
    [KEYS.L18N_KEY_LABEL_SAVED ]:"저장됨",
    [KEYS.L18N_KEY_LABEL_MY_PARTNERS ]:"내 파트너",
    [KEYS.L18N_KEY_LABEL_ADD ]:"추가",
    [KEYS.L18N_KEY_LABEL_REMOVE ]:"제거",
    [KEYS.L18N_KEY_LABEL_ADD_TO_COMPARE ]:"비교하기 위해 추가 ",
    [KEYS.L18N_KEY_LABEL_SELECT_AT_LEAST_ONE_MORE ]:"하나 이상 선택",
    [KEYS.L18N_KEY_LABEL_COMPARE_SELECTED ]:"선택 버전 비교 ",
    [KEYS.L18N_KEY_LABEL_REMOVE_FROM_COMPARATOR ]:"비교기에서 제거",
    [KEYS.L18N_KEY_LABEL_COMPARE ]:"비교",
    [KEYS.L18N_KEY_LABEL_PARTNER_LEVEL ]:"파트너 레벨",
    [KEYS.L18N_KEY_LABEL_PROCESSING_IN_PROGRESS]:"처리 진행 중",
    [KEYS.L18N_KEY_LABEL_RESULT ]:"result",
    [KEYS.L18N_KEY_LABEL_RESULTS ]:"결과",
    [KEYS.L18N_KEY_LABEL_NO_RESULTS ]:"결과 없음",
    [KEYS.L18N_KEY_LABEL_RESULT_IN]:"결과",
    [KEYS.L18N_KEY_LABEL_RESULTS_IN]:"결과",
    [KEYS.L18N_KEY_LABEL_NO_RESULTS_IN]:"결과 없음",
    [KEYS.L18N_KEY_LABEL_PREVIOUS ]:"이전",
    [KEYS.L18N_KEY_LABEL_PREV ]:"이전",
    [KEYS.L18N_KEY_LABEL_NEXT ]:"다음",
    [KEYS.L18N_KEY_LABEL_SAVE ]:"저장",
    [KEYS.L18N_KEY_LABEL_EXPERTISE ]:"전문 지식",
    [KEYS.L18N_KEY_LABEL_OVERVIEW ]:"개요",
    [KEYS.L18N_KEY_LABEL_IS_A_CISCO ]:"시스코입니다.",
    [KEYS.L18N_KEY_LABEL_ROLE_INTEGRATOR_DESCRIPTION]:"통합자는 고객용 엔드 투 엔드 솔루션을 구축합니다. 이들은 주로 재판매 전략으로 거래하지만 고객 비즈니스 문제를 해결하기 위해 고유한 전문 지식을 제공합니다.",
    [KEYS.L18N_KEY_LABEL_ROLE_PROVIDER_DESCRIPTION ]:"공급자는 매니지드 및 클라우드 솔루션을 제공하는 전문가입니다. 고객은 솔루션을 소비하는 방식에 있어 더욱 유연해지길 바라고 있으며 공급자는 시장에서 점점 더 중요해지고 있습니다.",
    [KEYS.L18N_KEY_LABEL_PAST_SEARCHES ]:"과거 검색",
    [KEYS.L18N_KEY_LABEL_PAST_SEARCH ]:"과거 검색",
    [KEYS.L18N_KEY_LABEL_ROLES ]:"역할 ",
    [KEYS.L18N_KEY_LABEL_TECHNOLOGY ]:"기술",
    [KEYS.L18N_KEY_LABEL_INDUSTRIES ]:"업종",
    [KEYS.L18N_KEY_LABEL_INTEGRATORS ]:"통합자",
    [KEYS.L18N_KEY_LABEL_PROVIDERS ]:"공급자",
    [KEYS.L18N_KEY_LABEL_OTHER ]:"기타",
    [KEYS.L18N_KEY_LABEL_OTHERS ]:"기타",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_OTHER_PARTNERS]:"다른 파트너가 저장되지 않음",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_INTEGRATORS ]:"저장된 통합자 없음",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_PROVIDERS ]:"저장된 제공자 없음",
    [KEYS.L18N_KEY_LABEL_FILTER_BY_NEED ]:"필요에 따라 필터링",
    [KEYS.L18N_KEY_LABEL_SEARCH_BY_COMBINED_CRITERIA ]:"통합 기준으로 검색",
    [KEYS.L18N_KEY_LABEL_SEARCH_BY_LOCATION ]:"위치 기준으로 검색",
    [KEYS.L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_WORLDWIDE]:"전 세계 곳곳에서 서비스를 제공하는 파트너가 1명 있습니다.",
    [KEYS.L18N_KEY_LABEL_THERE_ARE]:"스마트 어카운트와 연결된",
    [KEYS.L18N_KEY_LABEL_PARTNERS_SERVING_WORLDWIDE]:"전 세계 곳곳에서 서비스를 제공하는 파트너",
    [KEYS.L18N_KEY_LABEL_THERE_ARE_ONE_NO_PARTNERS_SERVING]:"서비스를 제공하는 파트너가 없습니다.",
    [KEYS.L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_IN]:"서비스를 제공하는 파트너가 1명 있습니다.",
    [KEYS.L18N_KEY_LABEL_PARTNERS_SERVING_IN]:"서비스를 제공하는 파트너",
    [KEYS.L18N_KEY_LABEL_THERE_ARE_ONE_PARTNERS_SERVING_IN]:"서비스를 제공하는 파트너가 없습니다.",
    [KEYS.L18N_KEY_LABEL_CHANGE_LOCATION]:"위치 변경",
    [KEYS.L18N_KEY_LABEL_FILTER_BY_NEED]:"요구 사항별 필터링",
    [KEYS.L18N_KEY_LABEL_SEARCH]:"검색",
    [KEYS.L18N_KEY_LABEL_BY_NAME_ONE_LEVEL_AND_EXPERTISE]:"이름, 레벨 및 전문 지식으로 검색",
    [KEYS.L18N_KEY_LABEL_SELECTED]:"선택됨",
    [KEYS.L18N_KEY_LABEL_NO_MATCHES_FOUND]:"일치하는 결과가 없습니다.",
    [KEYS.L18N_KEY_LABEL_RANK_UP]:"순위",
    [KEYS.L18N_KEY_LABEL_RANK_DOWN]:"순위 역순",
    [KEYS.L18N_KEY_LABEL_NAME_UP]:"이름순",
    [KEYS.L18N_KEY_LABEL_NAME_DOWN]:"이름 역순",
    [KEYS.L18N_KEY_LABEL_LOGIN_REQUIRED]:"로그인 필요",
    [KEYS.L18N_KEY_LABEL_YOU_MUST_ONE_PERFORM_THIS_ACTION]:"이 작업을 수행하려면 로그인해야 합니다.",
    [KEYS.L18N_KEY_LABEL_SEARCH_RESTORATION_FAILED]:"검색 복원 실패",
    [KEYS.L18N_KEY_LABEL_LOG_IN]:"로그인",
    [KEYS.L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_SAVED]:"파트너를 저장했습니다.",
    [KEYS.L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_SAVED]:"파트너를 저장할 수 없습니다.",
    [KEYS.L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_REMOVED]:"파트너를 삭제했습니다.",
    [KEYS.L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_DELETED]:"파트너를 삭제할 수 없습니다.",
    [KEYS.L18N_KEY_LABEL_TYPE_A_ONE_LEVEL_OR_EXPERTISE]:"이름, 레벨 또는 전문 지식으로 검색할 키워드 입력",
    [KEYS.L18N_KEY_LABEL_ROLE_DEVELOPER_DESCRIPTION]:"개발자는 시스코 기술을 바탕으로 맞춤형 소프트웨어 및 하드웨어 솔루션을 구축하여 시스템을 연결하고 결과를 제공하는 고유한 솔루션을 개발하는 전문가입니다.",
    [KEYS.L18N_KEY_LABEL_ROLE_ADVISOR_DESCRIPTION]:"어드바이저는 복잡한 비즈니스 과제에 대한 솔루션을 탐색할 때 기업을 안내하는 심층적인 업계 지식을 보유한 전문가입니다.",
    [KEYS.L18N_KEY_LABEL_DIVERSE_PARTNER]:"다양한 파트너",
    [KEYS.L18N_KEY_LABEL_ALPHABETICAL]:"알파벳순",
    [KEYS.L18N_KEY_LABEL_MOST_EXPERTISE]:"대부분의 전문성",
    [KEYS.L18N_KEY_LABEL_DEVELOPER]:"개발자",
    [KEYS.L18N_KEY_LABEL_ADVISOR]:"어드바이저",

    [KEYS.L18N_KEY_LABEL_FILTERS]:"필터",
    [KEYS.L18N_KEY_LABEL_FILTER_VERB]:"필터",
    [KEYS.L18N_KEY_LABEL_PARTNER_EXPERTISE]:"파트너 전문 지식",
    [KEYS.L18N_KEY_LABEL_DISMISS_VERB]:"해제",
    [KEYS.L18N_KEY_LABEL_SPECIALIZATION]:" 전문화",
    [KEYS.L18N_KEY_LABEL_EXPERTISES]:"전문 지식",
    [KEYS.L18N_KEY_LABEL_NO_DESCRIPTION_PROVIDED_DOT]:"설명이 제공되지 않았습니다.",
    [KEYS.L18N_KEY_LABEL_ABOUT]:"정보",
    [KEYS.L18N_KEY_LABEL_CLEAR_COMPARATOR]:"비교기 지우기",
    [KEYS.L18N_KEY_LABEL_PARTNER_COMPARISON]:"파트너 비교",
    [KEYS.L18N_KEY_LABEL_ROLE]:"역할",
    [KEYS.L18N_KEY_LABEL_TECHNOLOGICAL_FOCUS]:"기술적 초점",
    [KEYS.L18N_KEY_LABEL_DESCRIPTION]:"설명",
    [KEYS.L18N_KEY_LABEL_CHOOSE_LANGUAGE_SELECTION]:"언어 선택",
    [KEYS.L18N_KEY_LABEL_LOG_OUT]:"로그아웃",
    [KEYS.L18N_KEY_LABEL_INCLUSIVE_PARTNER]:"포용적인 파트너",

    [KEYS.L18N_KEY_LABEL_ABOUT_CISCO]: "시스코 소개",
    [KEYS.L18N_KEY_LABEL_CONTACT_US]: "문의하기",
    [KEYS.L18N_KEY_LABEL_CAREERS]: "채용",
    [KEYS.L18N_KEY_LABEL_MEET_OUR_PARTNERS]: "파트너 소개",
    [KEYS.L18N_KEY_LABEL_FEEDBACK]: "피드백",
    [KEYS.L18N_KEY_LABEL_HELP]: "도움말",
    [KEYS.L18N_KEY_LABEL_TERMS_AND_CONDITIONS]: "이용약관",
    [KEYS.L18N_KEY_LABEL_PRIVACY_STATEMENT]: "개인정보 보호 정책",
    [KEYS.L18N_KEY_LABEL_COOKIES]: "쿠키",
    [KEYS.L18N_KEY_LABEL_TRADEMARKS]: "상표",
    [KEYS.L18N_KEY_LABEL_SUPPLY_CHAIN_TRANSPARENCY]: "공급망 투명성",
    [KEYS.L18N_KEY_LABEL_SITEMAP]: "사이트맵",

    [KEYS.L18N_KEY_LABEL_ABOUT_CISCO]: "시스코 소개",
    [KEYS.L18N_KEY_LABEL_CONTACT_US]: "문의하기",
    [KEYS.L18N_KEY_LABEL_CAREERS]: "채용",
    [KEYS.L18N_KEY_LABEL_MEET_OUR_PARTNERS]: "파트너를 만나보세요",
    [KEYS.L18N_KEY_LABEL_FEEDBACK]: "피드백",
    [KEYS.L18N_KEY_LABEL_HELP]: "도움말",
    [KEYS.L18N_KEY_LABEL_TERMS_AND_CONDITIONS]: "이용약관",
    [KEYS.L18N_KEY_LABEL_PRIVACY_STATEMENT]: "개인정보 보호정책",
    [KEYS.L18N_KEY_LABEL_COOKIES]: "쿠키",
    [KEYS.L18N_KEY_LABEL_TRADEMARKS]: "상표",
    [KEYS.L18N_KEY_LABEL_SUPPLY_CHAIN_TRANSPARENCY]: "공급망 투명성",
    [KEYS.L18N_KEY_LABEL_SITEMAP]: "사이트맵",
    [KEYS.L18N_KEY_LABEL_HOW_TO_BUY]: "구매 방법",
    [KEYS.L18N_KEY_LABEL_PARTNERS]: "파트너",
    [KEYS.L18N_KEY_LABEL_PRODUCTS_AND_SERVICES]: "제품 및 서비스",
    [KEYS.L18N_KEY_LABEL_SOLUTIONS]: "솔루션",
    [KEYS.L18N_KEY_LABEL_SUPPORT]: "지원",
    [KEYS.L18N_KEY_LABEL_LEARN]: "배우기",
    [KEYS.L18N_KEY_LABEL_EXPLORE_CISCO]: "시스코 탐색",
    [KEYS.L18N_KEY_LABEL_MENU]: "메뉴",
    [KEYS.L18N_KEY_LABEL_CLOSE]: "닫기",
    [KEYS.L18N_KEY_LABEL_SEE_MORE]: "자세히 보기",
    [KEYS.L18N_KEY_LABEL_SEE_LESS]: "간략히 보기",
    [KEYS.L18N_KEY_LABEL_DONT_HAVE_AN_ACCOUNT]: "계정이 없습니까?",
    [KEYS.L18N_KEY_LABEL_SIGN_UP]: "가입"
  }
});

export default krKOTranslations;
